import React, { createContext, useContext, useState, ReactNode } from 'react';

let currentQuestionKeyGlobal: string | undefined = undefined;
export function getCurrentQuestionKey() {
  return currentQuestionKeyGlobal;
}

interface CurrentQuestionContextInterface {
  currentQuestionKey?: string;
  setCurrentQuestionKey: (key: string | undefined) => void;
}

export const CurrentQuestionContext = createContext<CurrentQuestionContextInterface>(
  {
    currentQuestionKey: undefined,
    setCurrentQuestionKey: () => {},
  }
);

interface CurrentQuestionProviderProps {
  children: ReactNode;
}

export const CurrentQuestionProvider = ({
  children,
}: CurrentQuestionProviderProps) => {
  const [key, setKey] = useState<string | undefined>(undefined);

  const updateKey = (newKey: string | undefined) => {
    setKey(newKey);
    currentQuestionKeyGlobal = newKey;
  };

  return (
    <CurrentQuestionContext.Provider
      value={{ currentQuestionKey: key, setCurrentQuestionKey: updateKey }}
    >
      {children}
    </CurrentQuestionContext.Provider>
  );
};

export const useCurrentQuestionContext = () => {
  return useContext(CurrentQuestionContext);
};
